import fetchClient from './fetchClient';
import { errorHandler } from './utils';

const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getPaginatedDevis = async (
    page: number,
    limit: number,
    status: string = 'all',
    search: string = '',
    range: any = null,
) => {
    let url = `/devis?limit=${limit}&page=${page}&status=${status}&search=${search}`;
    if (range) {
        const toISO = (d: any) =>
            d instanceof Date ? d.toISOString() : new Date(d).toISOString();
        url += `&start=${toISO(range.startDate)}&end=${toISO(range.endDate)}`;
    }

    const res: any = await fetchClient.get(url, config()).catch(() => null);
    if (!res) return null;
    return res.data;
};

export const getDevis = async (id: string) => {
    const res: any = await fetchClient
        .get(`/devis/${id}`, config())
        .catch(() => null);
    if (!res) return null;
    return res.data;
};

export const createDevis = async (devis: any) => {
    let res: any = null;
    try {
        res = await fetchClient.post('/devis', devis, config());
    } catch (err: any) {
        return { error: err?.response?.data?.error ?? err?.message ?? 'Error' };
    }
    if (!res?.data) return { error: 'Empty response' };
    return res.data;
};

export const updateDevis = async (devis: any) => {
    const id = devis._id;
    // getDevis() populates `customer` into a full object and returns the raw
    // Mongoose document (ownerId, createdAt, __v, ...). The backend validator
    // only accepts a specific whitelist (customerId as a plain string, no
    // unknown keys), so the payload must be rebuilt rather than spread as-is.
    const body: any = {
        devisNumber: devis.devisNumber,
        deliveryDate: devis.deliveryDate || undefined,
        validUntil: devis.validUntil || undefined,
        totalPrice: devis.totalPrice,
        customerId: devis.customerId || devis.customer?._id || devis.customer,
        customerNotes: devis.customerNotes,
        internalNotes: devis.internalNotes,
        items: devis.items,
        contactEmail: devis.contactEmail,
        globalDiscountType: devis.globalDiscountType,
        globalDiscountValue: devis.globalDiscountValue,
    };

    let res: any = null;
    try {
        res = await fetchClient.put(`/devis/${id}`, body, config());
    } catch (err: any) {
        return { data: null as any, error: err?.response?.data?.error ?? err?.message ?? 'Error' };
    }
    if (res?.data) return { data: res.data, error: null as any };
    return { data: null as any, error: null as any };
};

export const deleteDevis = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/devis/${id}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const sendDevisEmail = async (id: string) => {
    const res: any = await fetchClient
        .get(`/devis/${id}/send-email`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const acceptDevis = async (id: string) => {
    const res: any = await fetchClient
        .put(`/devis/${id}/accept`, {}, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const refuseDevis = async (id: string) => {
    const res: any = await fetchClient
        .put(`/devis/${id}/refuse`, {}, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getDevisNote = async (id: string) => {
    const fileConfig: any = {
        headers: {
            Authorization: config().headers.Authorization,
        },
        responseType: 'arraybuffer',
    };
    const res = await fetchClient
        .get(`/devis/${id}/devis-note`, fileConfig)
        .catch(() => null);
    if (!res) return null;
    return new Blob([res.data], { type: 'application/pdf' });
};
